/**
 * Created by Ella Ma on 07/12/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, fromEvent, of as observableOf } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { AuditTrailDialogService } from './audit-trail.service';
import { Activities, Viewers, OP_TYPE, TYPE, RNTRY, ENTIMENT, DOT_TYPE, ADHOC_TYPE, ENTRY_VALUE } from './audit-trail.model';
import { AuditTrailService } from '../../../tamalelibs/services/audit-trail.service';
import { Router } from '@angular/router';
import { WindowRef } from '../../../services/window-ref';

@Component({
    selector: 'tam-audit-trail',
    templateUrl: './audit-trail.component.html',
    styleUrls: ['./audit-trail.component.scss']
})
export class AuditTrailComponent implements OnInit, OnDestroy {

    private _getAuditTrailSubscription$: Subscription;
    private _opensubscription: Subscription;
    private _outsideClick$: Subscription;
    private _threadId: string;

    currentState: boolean;
    reloading = false;
    activities: Activities[] = [];
    viewers: Viewers[] = [];

    constructor(
        private _APIServices: AuditTrailService,
        private _router: Router,
        private _service: AuditTrailDialogService,
        private _winRef: WindowRef,
        private _datePipe: DatePipe,
    ) { }

    ngOnInit() {
        this.currentState = false;
        this._outsideClick$ = fromEvent(document, 'click').subscribe(() => {
            this.onClose();
        });

        this._opensubscription = this._service.open$.subscribe(data => {
            this._threadId = data.threadId;
            this._onOpen();
            this.reloading = true;
            this._getAuditTrailSubscription$ = this._APIServices.getAuditTrail(data.noteId, 'entry').pipe(
                take(1),
                catchError(() => {
                    this.reloading = false;
                    return observableOf();
                })).subscribe((res) => {
                    this.reloading = false;
                    if (res) {
                        this._formatResponseData(res['audit-list']);
                    }
                });
        });
    }

    ngOnDestroy(): void {
        if (this._getAuditTrailSubscription$) {
            this._getAuditTrailSubscription$.unsubscribe();
        }
        if (this._opensubscription) {
            this._opensubscription.unsubscribe();
        }
        if (this._outsideClick$) {
            this._outsideClick$.unsubscribe();
        }
    }

    viewDetail(data: Viewers) {
        const href = 'contact/' + data.userId;
        window.open(href);
    }

    onClickValue(item) {
        if (item.title === 'Body') {
            this._openThread();
        }
    }

    onClickInset(event: MouseEvent) {
        event.stopImmediatePropagation();
    }

    onClose() {
        this.reloading = false;
        this.activities = [];
        this.viewers = [];
        this.currentState = false;
    }

    trackByFn(index) {
        return index;
    }

    formatUpdateChanges(items, key, changes, opType) {
        const addType = opType === TYPE.ADD;
        const delType = opType === TYPE.DEL;
        if (key === RNTRY.BODY_PATH) {
            // TODO current BA not design
            items.push({
                title: ENTRY_VALUE[key],
                oldVal: addType ? '' : 'Detail',
                newVal: delType ? '' : 'Detail'
            });
        } else if (key === RNTRY.ENTITIES) {
            if (addType || delType) {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: addType ? '' : changes[key].map(item => item['short-name']).join(','),
                    newVal: delType ? '' : changes[key].map(item => item['short-name']).join(',')
                });
            } else {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: changes.before[key].map(item => item['short-name']).join(','),
                    newVal: changes.after[key].map(item => item['short-name']).join(',')
                });
            }
        } else if (key === RNTRY.SOURCE || key === RNTRY.SUBMITTER) {
            if (addType || delType) {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: addType ? '' : changes[key].name,
                    newVal: delType ? '' : changes[key].name
                });
            } else {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: changes.before[key].name,
                    newVal: changes.after[key].name
                });
            }
        } else if (key === RNTRY.SENTIMENT) {
            if (addType || delType) {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: addType ? '' : ENTIMENT[changes[key]],
                    newVal: delType ? '' : ENTIMENT[changes[key]]
                });
            } else {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: ENTIMENT[changes.before[key]],
                    newVal: ENTIMENT[changes.after[key]]
                });
            }
        } else if (key === RNTRY.DISPLAY_DATE) {
            if (addType || delType) {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: addType ? '' : this._datePipe.transform(changes[key], 'dd MMM yyyy'),
                    newVal: delType ? '' : this._datePipe.transform(changes[key], 'dd MMM yyyy')
                });
            } else {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: this._datePipe.transform(changes.before[key], 'dd MMM yyyy'),
                    newVal: this._datePipe.transform(changes.after[key], 'dd MMM yyyy')
                });
            }
        } else if (key === RNTRY.ADHOCS) {
            if (addType || delType) {
                const adHocs = changes[key];
                if (adHocs && adHocs.length > 0) {
                    adHocs.forEach((adHoc, index) => {
                        if (adHoc['data-type'] === ADHOC_TYPE.DATE) {
                            items.push({
                                title: ENTRY_VALUE[adHoc.title] || adHoc.title,
                                oldVal: addType ? '' : this._datePipe.transform(adHoc.value, 'dd MMM yyyy'),
                                newVal: delType ? '' : this._datePipe.transform(changes[key][index].value, 'dd MMM yyyy')
                            });
                        } else if (adHoc['data-type'] === ADHOC_TYPE.ENTITY) {
                            const value = changes[key][index] && changes[key][index].value;
                            let newVal;
                            if (Array.isArray(value)) {
                                newVal = value.map(item => item['short-name']).join(',');
                            } else {
                                newVal = value || '';
                            }
                            items.push({
                                title: ENTRY_VALUE[adHoc.title] || adHoc.title,
                                oldVal: addType ? '' : adHoc.value.map(item => item['short-name']).join(','),
                                newVal: delType ? '' : newVal
                            });
                        } else {
                            // enter the branch in two cases
                            // 1-add, delete common type adhoc;
                            // 2-remove from template, can't get date-type, if not entity, default is displayed as it is
                            items.push({
                                title: ENTRY_VALUE[adHoc.title] || adHoc.title,
                                oldVal: addType ? '' : adHoc.value,
                                newVal: delType ? '' : changes[key][index].value
                            });
                        }
                    });
                }
            } else {
                const adHocs = changes.before[key];
                if (adHocs && adHocs.length > 0) {
                    adHocs.forEach((adHoc, index) => {
                        if (adHoc['data-type'] === ADHOC_TYPE.DATE) {
                            items.push({
                                title: ENTRY_VALUE[adHoc.title] || adHoc.title,
                                oldVal: this._datePipe.transform(adHoc.value, 'dd MMM yyyy'),
                                newVal: this._datePipe.transform(changes.after[key][index].value, 'dd MMM yyyy')
                            });
                        } else if (adHoc['data-type'] === ADHOC_TYPE.ENTITY) {
                            const value = changes.after[key][index] && changes.after[key][index].value;
                            let newVal;
                            if (Array.isArray(value)) {
                                newVal = value.map(item => item['short-name']).join(',');
                            } else {
                                newVal = value || '';
                            }
                            items.push({
                                title: ENTRY_VALUE[adHoc.title] || adHoc.title,
                                oldVal: adHoc.value.map(item => item['short-name']).join(','),
                                newVal: newVal
                            });
                        } else {
                            items.push({
                                title: ENTRY_VALUE[adHoc.title] || adHoc.title,
                                oldVal: adHoc.value,
                                newVal: changes.after[key][index].value
                            });
                        }
                    });
                }
            }
        } else if (key === RNTRY.FILES) {
            let files;
            if (addType || delType) {
                files = changes[key];
                files.forEach(file => {
                    items.push({
                        title: ENTRY_VALUE[key],
                        oldVal: addType ? '' : file.subject,
                        newVal: delType ? '' : file.subject
                    });
                });
            } else {
                files = changes.before[key];
                files.forEach((file, index) => {
                    items.push({
                        title: ENTRY_VALUE[key],
                        oldVal: file.subject,
                        newVal: changes.after[key][index].subject
                    });
                });
            }
        } else if (key === RNTRY.ENTRY_TYPE) {
            if (addType || delType) {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: addType ? '' : changes[key].name,
                    newVal: delType ? '' : changes[key].name
                });
            } else {
                items.push({
                    title: ENTRY_VALUE[key],
                    oldVal: changes.before[key].name,
                    newVal: changes.after[key].name
                });
            }
        } else {
            /*
            * enter this branch, key === RNTRY.PRIORITY || key === RNTRY.SUBJECT, or key do not know type
            * default is displayed as it is
            */
            if (addType || delType) {
                items.push({
                    title: ENTRY_VALUE[key] || key,
                    oldVal: addType ? '' : changes[key],
                    newVal: delType ? '' : changes[key]
                });
            } else {
                items.push({
                    title: ENTRY_VALUE[key] || key,
                    oldVal: changes.before[key],
                    newVal: changes.after[key]
                });
            }
        }
    }

    private _onOpen() {
        this.currentState = true;
    }

    private _formatChanges(activity) {
        const items = [];
        const add_changes = activity.changed.add || {};
        const update_changes = activity.changed.update || {};
        const del_changes = activity.changed.delete || {};
        Object.keys(add_changes).forEach((key) => {
            this.formatUpdateChanges(items, key, add_changes, TYPE.ADD);
        });
        Object.keys(del_changes).forEach((key) => {
            this.formatUpdateChanges(items, key, del_changes, TYPE.DEL);
        });
        Object.keys(update_changes.after || {}).forEach((key) => {
            this.formatUpdateChanges(items, key, update_changes, TYPE.EDIT);
        });
        return items;
    }

    private _formatUser(user) {
        let name = '', id = '';
        if (user && user.link) {
            const arr = user.link.href.split('/');
            id = arr[arr.length - 2];
            name = user.link.phid;
        }
        return { name, id };
    }

    private _formatResponseData(res) {
        const activities: Activities[] = [];
        const viewers: Array<any> = [];
        // viewer sort by 'asc'
        res.filter((item) => item.type === TYPE.VIEW)
            .sort((a, b) => a.time - b.time)
            .forEach((data) => {
                const id = this._formatUser(data.user).id;
                if (viewers.findIndex(item => item.userId === id) === -1) {
                    viewers.push({
                        userName: this._formatUser(data.user).name,
                        userId: id
                    });
                }
            });
        res.filter((item) => item.type !== TYPE.VIEW)
            .sort((a, b) => a.time - b.time)
            .forEach(activity => {
                const type = DOT_TYPE[activity.type];
                const userId = this._formatUser(activity.user).id;
                const userName = this._formatUser(activity.user).name;
                const date = this._datePipe.transform(activity.time, 'dd MMM yyyy, HH:mm');
                const opType = OP_TYPE[activity.type] || '';
                const items = this._formatChanges(activity);
                activities.push({ type, opType, userId, userName, date, items });
            });
        this.activities = activities;
        this.viewers = viewers;
    }

    private _openThread() {
        const win = this._winRef.nativeWindow;
        const prefixIndex = win.location.href.indexOf(this._router.url);
        let fileUrl = win.location.href.substring(0, prefixIndex) + '/entry/';
        if (this._threadId) {
            fileUrl += this._threadId;
        }
        window.open(fileUrl);
    }
}
